export default "__VITE_ASSET__CXx2TIcQ__"